// Tiny sessionStorage-backed store for the active "View As" target's user id.
//
// Read synchronously by api/client.js on EVERY request — outside React, so
// this can't be React state. Written to by context/AuthContext.js's
// startViewAs/stopViewAs, which is the only place that should ever call the
// setters; everything else should read `me.view_as` from AuthContext instead
// of reaching in here directly.
//
// sessionStorage (not localStorage) so a closed tab always starts as its own
// real identity — the same scoping choice `stinte_draft:*` and the page-size
// preference make for per-session state, just narrower.
const KEY = "stinte_view_as_uid";

export function getViewAsUserId() {
  try {
    return sessionStorage.getItem(KEY) || null;
  } catch {
    // sessionStorage throws in Safari private mode — never impersonate by
    // accident, so treat a failed read as "not viewing as anyone".
    return null;
  }
}

export function setViewAsUserId(userId) {
  try {
    sessionStorage.setItem(KEY, userId);
  } catch {
    /* ignore */
  }
}

export function clearViewAsUserId() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
